// extracted by mini-css-extract-plugin
export default {"scriptBox":"ScriptBox_scriptBox__5AaAM","msg":"ScriptBox_msg__Ygtk-","h3":"ScriptBox_h3__pMctf","chatIcon":"ScriptBox_chatIcon__k2zRD"};